import type { QrCodeProps } from "../types";
import { QR_MARGIN } from "./qr-geometry";
import { buildQrMatrix } from "./qr-matrix";

/** Whether a logo / image / icon will be drawn in the middle of the code. */
export const hasCenterArt = ({
  centerType,
  centerImage,
  centerIcon,
}: Pick<QrCodeProps, "centerType" | "centerImage" | "centerIcon">) =>
  centerType === "icon"
    ? !!centerIcon
    : (centerType === "logo" || centerType === "image") &&
      !!centerImage &&
      !centerImage.includes("{{");

/**
 * Below ~3 screen pixels per module, decoders start missing codes (measured
 * with jsQR across every dot/corner style). A longer link means more modules,
 * and a centre logo forces level H, which adds more.
 */
export const MIN_PX_PER_MODULE = 3;

export const qrPxPerModule = (
  value: string,
  withCenter: boolean,
  sizePx: number,
) => {
  const matrix = buildQrMatrix(value, withCenter ? "H" : "M");
  return matrix ? sizePx / (matrix.length + 2 * QR_MARGIN) : 0;
};
